import { trpc, type RouterInputs, type RouterOutputs } from '@klear/ui/lib/trpc'

export type OrderListRead = RouterOutputs['order']['list'][number]

export type OrderListFilters = Omit<RouterInputs['order']['list'], 'traderId'>

export function useOrders(traderId?: number, filters?: OrderListFilters) {
  const {
    data: orders = [],
    error,
    isLoading
  } = trpc.order.list.useQuery({
    traderId: traderId || undefined,
    ...filters
  })

  return { orders, error, isLoading }
}
